import { render, staticRenderFns } from "./BasicLanguagePicker.vue?vue&type=template&id=1e27416a&"
import script from "./BasicLanguagePicker.vue?vue&type=script&lang=js&"
export * from "./BasicLanguagePicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports